import React from "react";

// Simple admin auth using session storage; password is checked locally.
// NOTE: This is client-side only (MVP). Backend auth should be added for production.

const PASSWORD = "JESUS"; // owner password (as requested)
const KEY = "3e_admin_token";
const TOKEN_VALUE = "owner-authenticated";

// Module-level subscription so multiple components share state
const subscribers = new Set();
function notify() { subscribers.forEach((fn) => { try { fn(); } catch {} }); }

export function isAdminAuthed() {
  try { return sessionStorage.getItem(KEY) === TOKEN_VALUE; } catch { return false; }
}

export function adminLogin(pwd) {
  if ((pwd || "").trim() === PASSWORD) {
    try { sessionStorage.setItem(KEY, TOKEN_VALUE); } catch {}
    notify();
    return true;
  }
  return false;
}

export function adminLogout() {
  try { sessionStorage.removeItem(KEY); } catch {}
  notify();
}

export function useAdminAuth() {
  const [authed, setAuthed] = React.useState(isAdminAuthed());
  React.useEffect(() => {
    const update = () => setAuthed(isAdminAuthed());
    subscribers.add(update);
    const onStorage = () => update();
    window.addEventListener("storage", onStorage);
    return () => {
      subscribers.delete(update);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return {
    authed,
    login: (p) => adminLogin(p),
    logout: () => adminLogout(),
  };
}
